import React, { useState, useEffect } from "react";
import {
  fetchModules,
  fetchAllModules,
  fetchAvailableLwNames,
} from "../../actions/moduleActions";
import { Button, Row, Col, Input, Table } from "reactstrap";
import CreateModule from "../../components/Modal/CreateModule";
import ModuleTypeIcon from "../../components/Module/ModuleTypeIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getWinOptions, composeUrl } from "../../Utilities/moduleHelper";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import SetCourseModuleSortOrderModal from "../../components/Modal/SetCourseModuleSortOrderModal";
import { unlockTeacherFinalExam } from "../../actions/teacherCoursesAction";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { injectIntl } from "react-intl";

function CourseModulesList(props) {
  const [filterSearch, setFilterSearch] = useState("");
  const [createModal, setCreateModal] = useState(false);
  const [moduleTypeScorm, setModuleTypeScorm] = useState(true);
  const [createNewModule, setCreateNewModule] = useState(false);
  const [createdModuleId, setCreatedModuleId] = useState(0);
  const [allModules, setAllModules] = useState([]);
  const [currentModules, setCurrentModules] = useState([]);
  const [sortModalIsOpen, setSortModalIsOpen] = useState(false);
  const [editDefQuesCountModuleId, setEditDefQuesCountModuleId] =
    useState(null);
  const [newDefaultQuesCount, setNewDefaultQuesCount] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const modulesReducer = useSelector((state) => state.moduleReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchModules(props.location.state.courseId));
    dispatch(fetchAllModules());
    dispatch(fetchAvailableLwNames());
  }, [dispatch, props.location.state.courseId]);

  useEffect(() => {
    if (modulesReducer.modules.length > 0) {
      setAllModules(
        modulesReducer.modules.sort((a, b) =>
          a.sortOrder > b.sortOrder ? 1 : b.sortOrder > a.sortOrder ? -1 : 0
        )
      );
    }
    if (modulesReducer.result.length > 0) {
      setCurrentModules(
        modulesReducer.result.sort((a, b) =>
          a.sortOrder > b.sortOrder ? 1 : b.sortOrder > a.sortOrder ? -1 : 0
        )
      );
    }
  }, [modulesReducer.modules, modulesReducer.result]);

  useEffect(() => {
    if (filterSearch.length > 0) {
      setCurrentModules(
        modulesReducer.result.filter((mod) => {
          if (mod.module.name.toLowerCase().indexOf(filterSearch) !== -1) {
            return mod;
          }
          return null;
        })
      );
    }
  }, [filterSearch, modulesReducer.result]);

  if (modulesReducer.loading) {
    <Pacmanloader />;
  }

  const loadModules = () => {
    dispatch(fetchModules(props.location.state.courseId));
  };

  const loadAllModules = () => {
    dispatch(fetchAllModules());
  };

  const toggleModal = () => {
    setCreateModal(!createModal);
  };

  const deleteCourseModule = () => {
    toast.warn(
      <FormattedMessage id="ContactAdministratorToRemoveCourseModule" />
    );
  };

  const setHideStatus = (courseModuleId, hideForStudents, hideForTeachers) => {
    axios
      .post(`${API_BASE_URL}/Module/SetHideStatus/`, {
        id: courseModuleId,
        hideForStudents: hideForStudents,
        hideForTeachers: hideForTeachers,
      })
      .then(() => {
        toast.success("Hide status ändrad", TOAST_CONFIG);
        loadModules();
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att sätta hide status",
          TOAST_CONFIG
        );
      });
  };

  const toggleCreateOrAdd = () => {
    setCreateNewModule(!createNewModule);
  };

  const toggleModuleType = () => {
    setModuleTypeScorm(!moduleTypeScorm);
  };

  const goToSelectModules = (moduleId) => {
    setCreatedModuleId(moduleId);
    setCreateNewModule(false);
  };

  const handleFilterSearch = (event) => {
    setFilterSearch(event.target.value);
  };

  const getAllModulesNotInThisCourse = () => {
    var currentModules = modulesReducer.result;

    var currentModulesToCourseIds = currentModules.map((x) => x.moduleId);

    var notInThisCourse = allModules.filter((mod) => {
      if (currentModulesToCourseIds.indexOf(mod.id) === -1) {
        return mod;
      }

      return null;
    });

    return notInThisCourse;
  };

  const openModule = (
    courseId,
    moduleId,
    moduleUrl,
    moduleType,
    isGy25FinalExam
  ) => {
    const studentResultId = -1;
    const userId = -1;

    if (moduleUrl == null) {
      toast.error(
        <FormattedMessage id="Tostify.Message.ModuleUrlMissing" />,
        TOAST_CONFIG
      );
      return;
    }
    dispatch(unlockTeacherFinalExam(courseId, moduleId)).then(() => {
      var url = composeUrl(
        userId,
        courseId,
        moduleId,
        moduleType,
        studentResultId,
        moduleUrl,
        null,
        null,
        isGy25FinalExam
      );

      var winOptions = getWinOptions();
      window.open(url, "", winOptions);
    });
  };

  const handleSetDefNbrOfFinalExamQuestions = (courseModuleId, value) => {
    axios
      .post(
        `/Module/SetDefNbrOfFinalExQuestions?courseModuleId=${courseModuleId}&defaultNumberOfQuestions=${value}`
      )
      .then((response) => {
        toast.success(
          <FormattedMessage id="DefaultQuestionCountChangeSuccess" />,
          TOAST_CONFIG
        );
        setCurrentModules((prevModules) =>
          prevModules.map((module) =>
            module.courseModuleId === courseModuleId
              ? {
                  ...module,
                  defNbrOfFinalExQuestions:
                    response.data.result.defNbrOfFinalExQuestions,
                }
              : module
          )
        );
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data && (
            <FormattedMessage id="DefaultQuestionCountChangeFail" />
          ),
          TOAST_CONFIG
        );
      });
  };

  const validateInput = (value, defaultValue, maxValue) => {
    if (isNaN(value) || value < 0) {
      setErrorMessage(props.intl.formatMessage({ id: "EnterValidNumber" }));
      return false;
    }
    if (maxValue != null && maxValue !== "" && value > maxValue) {
      setErrorMessage(props.intl.formatMessage({ id: "EnterSmallerNumber" }));
      return false;
    }
    if (value === defaultValue) {
      setEditDefQuesCountModuleId(null);
      setNewDefaultQuesCount("");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleBlur = (courseModule, maxQuestions, inputValue) => {
    const parsedValue = parseInt(inputValue, 10);
    const defaultNumber = courseModule.defNbrOfFinalExQuestions;

    if (!validateInput(parsedValue, defaultNumber, maxQuestions)) return;

    handleSetDefNbrOfFinalExamQuestions(
      courseModule.courseModuleId,
      parsedValue
    );
    setEditDefQuesCountModuleId(null);
    setNewDefaultQuesCount("");
  };

  const getMaxNumberOfQuestions = (courseModule) => {
    if (courseModule.module.hasQApiFetchError) return "E";
    return courseModule.module.numberOfQuestions ?? "";
  };

  const renderQuestionCountInput = (courseModule) => {
    const defaultCount = courseModule.defNbrOfFinalExQuestions ?? 0;
    const maxQuestions = getMaxNumberOfQuestions(courseModule);
    const isEditing =
      maxQuestions !== 0 &&
      editDefQuesCountModuleId === courseModule.courseModuleId;
    const currentValue = isEditing ? newDefaultQuesCount : defaultCount;

    return (
      <>
        {courseModule.module.isGy25TestModule &&
          !courseModule.module.isFinalExam && (
            <div className="set-number-section d-flex align-items-center">
              {isEditing ? (
                <Input
                  type="number"
                  min="0"
                  max={maxQuestions}
                  value={currentValue}
                  onBlur={() =>
                    handleBlur(courseModule, maxQuestions, currentValue)
                  }
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    handleBlur(courseModule, maxQuestions, currentValue)
                  }
                  onChange={(e) => setNewDefaultQuesCount(e.target.value)}
                  className="number-input"
                  title={errorMessage}
                />
              ) : (
                <Button
                  onClick={() => {
                    setEditDefQuesCountModuleId(courseModule.courseModuleId);
                    setNewDefaultQuesCount(defaultCount);
                  }}
                  className="btn-set-number p-1"
                  title={props.intl.formatMessage({
                    id: "DefaultQuestionCountTooltip",
                  })}
                >
                  {defaultCount === "" ? (
                    <FontAwesomeIcon icon={faPen} />
                  ) : (
                    defaultCount
                  )}
                </Button>
              )}
              {maxQuestions !== "" && (
                <>
                  <span className="me-1">/</span>
                  <span
                    title={
                      courseModule.module.hasQApiFetchError
                        ? props.intl.formatMessage({
                            id: "CouldNotGetMaxValue",
                          })
                        : props.intl.formatMessage({ id: "MaxQuestionCount" })
                    }
                    className={
                      courseModule.module.hasQApiFetchError &&
                      "text-danger input-feedback"
                    }
                  >
                    {maxQuestions}
                  </span>
                </>
              )}
              {defaultCount !== "" && (
                <span className="set-number-span">
                  <FontAwesomeIcon icon={faPen} className="edit-icon" />{" "}
                </span>
              )}
            </div>
          )}
      </>
    );
  };

  var mappedModulesComp = currentModules?.map((courseModule, id) => {
    return (
      <tr key={id} style={{ verticalAlign: "middle" }}>
        <td>
          <ModuleTypeIcon moduleType={courseModule.module.moduleType} />
        </td>
        <td>
          {courseModule.module.moduleType !== "LearnWare" ? (
            <Button
              color="link"
              onClick={() =>
                openModule(
                  courseModule.courseId,
                  courseModule.moduleId,
                  courseModule.module.url,
                  courseModule.module.moduleType,
                  courseModule.module.isFinalExam &&
                    courseModule.module.maxScoreIsSetByModule
                )
              }
              disabled={
                courseModule.module.isFinalExam &&
                courseModule.module.maxScoreIsSetByModule
              }
            >
              <FontAwesomeIcon
                icon="play-circle"
                size="2x"
                className="text-primary"
              />
            </Button>
          ) : (
            ""
          )}
        </td>
        <td>{courseModule.module.name}</td>
        <td align="right">{courseModule.moduleId}</td>
        <td align="right">{courseModule.courseModuleId}</td>
        <td align="right">{courseModule.module.moduleCoupleId}</td>
        <td align="right">{courseModule.module.maxScore}</td>
        <td align="right">{courseModule.module.approveScoreLimit}</td>
        <td align="right">{courseModule.module.maxActivityPoints}</td>

        <td align="center">
          {courseModule.module.isFinalExam ? (
            <FontAwesomeIcon icon="check" />
          ) : (
            <span />
          )}
        </td>
        <td align="center">
          {courseModule.module.maxScoreIsSetByModule ? (
            <FontAwesomeIcon icon="check" />
          ) : (
            <span />
          )}
        </td>
        <td align="center">
          {courseModule.module.isFactModule ? (
            <FontAwesomeIcon icon="check" />
          ) : (
            <span />
          )}
        </td>
        <td align="center">{renderQuestionCountInput(courseModule)}</td>
        <td align="center">
          <Button
            size="sm"
            outline
            color="blue"
            onClick={() =>
              setHideStatus(
                courseModule.courseModuleId,
                !courseModule.hideForStudents,
                courseModule.hideForTeachers
              )
            }
          >
            <FontAwesomeIcon
              icon="check"
              opacity={courseModule.hideForStudents ? 1 : 0}
            />
          </Button>
        </td>

        <td align="center">
          <Button
            size="sm"
            outline
            color="blue"
            onClick={() =>
              setHideStatus(
                courseModule.courseModuleId,
                courseModule.hideForStudents,
                !courseModule.hideForTeachers
              )
            }
          >
            <FontAwesomeIcon
              icon="check"
              opacity={courseModule.hideForTeachers ? 1 : 0}
            />
          </Button>
        </td>

        <td>{courseModule.module.qApiId}</td>

        <td>
          <Button
            size="sm"
            outline
            color="danger"
            title={"Ta bort modulen från kursen:" + courseModule.module.name}
            onClick={() =>
              deleteCourseModule(courseModule.courseId, courseModule.moduleId)
            }
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">
          <Button
            color="link"
            onClick={() => props.history.push("/superuser/courses")}
          >
            <span className="fa fa-chevron-left fa-2x" />
          </Button>
          {props.location.state.courseName} : Kopplade moduler
          <Button
            color="link"
            className="float-end"
            onClick={() => {
              toggleModal();
            }}
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;Koppla befintlig modul
          </Button>
          <span className="ms-2">
            (
            <FormattedMessage id="CourseId" /> {props.location.state.courseId})
          </span>
          <Button
            color="link"
            className="float-end"
            onClick={() => {
              setSortModalIsOpen(!sortModalIsOpen);
            }}
          >
            <FontAwesomeIcon icon="edit" />
            &nbsp;
            <FormattedMessage id="ChangeOrderForModulesInCourse" />
          </Button>
        </h5>
      </div>
      <div
        className="container-fluid admin-container "
        style={{ overflowX: "auto" }}
      >
        <Row>
          <Col className="col-12">
            <Row>
              <Col className="col-3 mb-2">
                <Input
                  className="search-input"
                  placeholder="Sök modul"
                  onChange={handleFilterSearch.bind(this)}
                />
              </Col>
            </Row>
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <Table hover className="table table-striped">
                <thead className="sticky-header">
                  <tr>
                    <th>
                      <FormattedMessage id="Type" />
                    </th>
                    <th>
                      <FormattedMessage id="Test" />
                    </th>
                    <th>
                      <FormattedMessage id="Name" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="ModuleId" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="CourseModuleId" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="CoupleId" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="MaxScore" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="ApproveScoreLimitInPercentage" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="MaxActivityPoints" />
                    </th>
                    <th>
                      <FormattedMessage id="FinalExam" />
                    </th>
                    <th>
                      <FormattedMessage id="Gy25" />
                    </th>
                    <th>
                      <FormattedMessage id="FactModule" />
                    </th>
                    <th
                      title={props.intl.formatMessage({
                        id: "QuestionCountHeaderTooltip",
                      })}
                    >
                      <FormattedMessage id="QuestionCountDefMax" />
                    </th>
                    <th>
                      <FormattedMessage id="HiddenForStudents" />
                    </th>
                    <th>
                      <FormattedMessage id="HiddenForTeachers" />
                    </th>
                    <th>
                      <FormattedMessage id="QApiId" />
                    </th>
                    <th>
                      <FormattedMessage id="Delete" />
                    </th>
                  </tr>
                </thead>
                <tbody>{mappedModulesComp}</tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>

      <CreateModule
        isOpen={createModal}
        toggle={toggleModal}
        reloadModules={loadModules}
        courseId={props.location.state.courseId}
        courseName={props.location.state.courseName}
        dismissModal={toggleModal.bind(this)}
        modules={getAllModulesNotInThisCourse()}
        createNew={createNewModule}
        goToSelectModule={goToSelectModules}
        createModuleTypeScorm={moduleTypeScorm}
        changeModuleType={toggleModuleType}
        toggleCreateOrAdd={toggleCreateOrAdd}
        reloadAllModules={loadAllModules}
        createdModuleId={createdModuleId}
      />
      <SetCourseModuleSortOrderModal
        isOpen={sortModalIsOpen}
        toggle={() => setSortModalIsOpen(!sortModalIsOpen)}
        modules={currentModules}
        courseId={props.location.state.courseId}
        reloadModules={loadModules}
      />
    </div>
  );
}

export default injectIntl(CourseModulesList);
